import React, { useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControlLabel,
  Stack,
  Switch,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialSelect from "../../../../components/MasterSelect";
import { useState } from "react";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useLocation, useParams } from "react-router-dom";
import BASEURL from "../../../Utils/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import manager from "../../../../assest/images/manager.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";
import { useLoading } from "../../../../context/loading";
import MaterialInput from "../../../../components/MaterialInput";
const AddManager = () => {
  const navigate = useNavigate();
  const { AccessData } = useUserDetails();
  const params = useLocation();
  // const { id } = useParams()
  // console.log('params:', id)

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [Department,setDepartment] = useState('')

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const { circleLoading, setCirleLoading } = useLoading();
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [managerData, setManagerData] = useState({
    userName: null,

    userNameStatus: "unchecked",
  });
  const [resource, setResource] = useState({
    userName: [],
  });

  const [id, setId] = useState(null);
  // const [viewData, setViewData] = useState('')
  const [viewManagerData, setViewManagerData] = useState({
    id: null,
    userName: "",
    empid: null,
    designation: "",
    status: null,
  });

  const [originalWeekoffData, setOriginalWeekoffData] = useState({
    id: null,
    userName: "",
    empid: null,
    designation: "",
    status: null,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    getManagerDetails();
    if (id) {
      getInitData(id);
    }
  }, []);

  // useEffect(() => {
  //     onfilterData()
  // }, [viewData])

  const [Userdatas,setUserdatas] = useState([])

  const getManagerDetails = async () => {
    const query = `query{
                 allUsersDetail{
                         id
                       firstName
                       department
                         empid
                      email
                        }
                       }`;

    const query1 = `  
                       query{
                      allManagers{
                        id
                        status
                        lastupdate
                        user{
                          id
                          empid
                          department
                          firstName
                          lastName
                          
                        }
                      }
                    }
                    `;

    console.log("getData:", query);

    try {
      setPageState({ ...pageState, loading: true });

      // const response = await axios.post(
      //   BASEURL,
      //   {
      //     query: query,
      //   },
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      // console.log("getManagerDetails:", response);
      // const managerListdata = response.data.data.allUsersDetail;
      // setResource({
      //   ...resource,
      //   userName: managerListdata,
      // });

      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          { query },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          { query: query1 },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      const Alluserdetails = response1.data.data.allUsersDetail || [];
      const Allmangerdeatils = response2.data.data.allManagers || [];
      setUserdatas(Alluserdetails)
      if (Allmangerdeatils != "") {
        const managerEmpIds = Allmangerdeatils.map(
          (manager) => manager.user.empid
        );
        const data = Alluserdetails.filter(
          (user) => !managerEmpIds.includes(user.empid)
        );

        setResource({
          ...resource,
          userName: data,
        });
      } else {
        setResource({
          ...resource,
          userName: Alluserdetails,
        });
      }

      setTogglePage({
        ...togglePage,
        view: params.search !== "" ? true : false,
      });
      setPageState({ ...pageState, loading: false, state: "success" });

      // console.log("Response managerListdata:", managerListdata);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const getInitData = async (id) => {
    const query = `query get_manager($id: String!){
        getManagerById(id: $id){
        id
        status
        user {
          id
          firstName
          empid
        }
  }
}`;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Extract Leavetype data from the response
      console.log("getInitDataResponse:", response);
      // const managerRowdata = response.data.data.getManagerById?.user?.username;
      const managerRowdata = response.data.data.getManagerById;

      console.log("managerRowdata", managerRowdata);
      setViewManagerData({
        ...viewManagerData,
        id: managerRowdata.id,
        userName: managerRowdata.user.firstName,
        empid: managerRowdata.user.empid,
        designation: managerRowdata.user.designation,
        status: managerRowdata.status,
      });
      // setViewData(managerRowdata)
      setOriginalWeekoffData({
        ...originalWeekoffData,
        id: managerRowdata.id,
        userName: managerRowdata.user.firstName,
        empid: managerRowdata.user.empid,
        designation: managerRowdata.user.designation,
        status: managerRowdata.status,
      });

      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  console.log("originalWeekoffData:", originalWeekoffData);

  const onManagerSubmit = async () => {
    setCirleLoading(true);
    const query = `
           
            mutation addManager($id:String! $status:Boolean!){
  addmanagerApproval(id:$id status:$status){
    managerapproval{
      id
      status
      lastupdate
      user{
        id
        
        firstName
      }
    }
  }
}
                `;

    try {
      console.log("managerData.id:", managerData.id);

      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: managerData.userName.value,
            // username: managerData.userName.value,
            status: true,
          },
        }),
      });

      console.log("response:", response.data);

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //   ...snackBar,
      //   Success: true,
      // });

      // navigate("/manager-management");
      if (response?.data?.data?.addmanagerApproval?.managerapproval) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Manager Added successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        navigate("/manager-management");
        setCirleLoading(false);
      }
    } catch (error) {
      console.error("responseError:", error.response.data);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for the inconvenience. There was a network issue. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      setCirleLoading(false);
    }
  };

  console.log("viewManagerData:", viewManagerData);

  const decodeBase64Id = (base64Id) => {
    try {
      const decodedString = atob(base64Id); // Decode the Base64 string

      return decodedString; // Return the numeric part
    } catch (error) {
      console.error("Error decoding Base64 ID:", error);
      return null;
    }
  };

  const onEditManager = async () => {
    setCirleLoading(true);
    const query = `
      mutation updateManager($id: String!, $status: Boolean!) {
        editManager(id: $id, status: $status) {
          managerupdate {
            id
            status
          }
        }
      }
    `;

    const encodedId = btoa(id);

    let data = {
      id: "VXNlck5vZGU6" + "" + encodedId,
      status: viewManagerData?.status,
    };

    console.log("Datatata:", data);

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id,
            // id: "VXNlck5vZGU6" + "" + encodedId,
            status: viewManagerData?.status, // Ensure this is a Boolean value
          },
        }),
      });
      console.log("response:", response.data);

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //   ...snackBar,
      //   Success: true,
      // });
      if (response?.data?.data?.editManager?.managerupdate) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Manager Updated successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/manager-management");
        setCirleLoading(false);
      }
    } catch (error) {
      console.error("responseError:", error.response.data);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for the inconvenience. There was a network issue. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      setCirleLoading(false);
    }
  };

  const onManagerDelete = async () => {
    const query = `mutation deleteManager($id:String!){
    managerdelete(id:$id){
    deletemanager
    }}`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
          },
        }),
      });
      console.log("response:", response);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //   ...snackBar,
      //   Success: true,
      // });
      // navigate("/manager-management");
      if (response?.data?.data?.managerdelete?.deletemanager) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Manager Deleted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/manager-management");
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for the inconvenience. There was a network issue. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleManagerDataChange = (event, selectEvent) => {
    let managerState = { ...managerData };
    let Labeldata = event.value

    let filterdata = Userdatas.filter((val)=> val.id == Labeldata)

  let Dep = filterdata[0]?.department

   setDepartment(Dep)

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "userName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          managerState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          managerState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      managerState[selectEvent.name] = event;
    }
    setManagerData(managerState);
  };

  const handleChange = (event) => {
    setViewManagerData({
      ...viewManagerData,
      [event.target.name]: event.target.checked,
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handleAddManager = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onManagerSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteManager = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to delete?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onManagerDelete();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (managerData.userNameStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDepartment();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardDepartment = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setViewManagerData({
      id: originalWeekoffData.id,
      userName: originalWeekoffData.userName,
      empid: originalWeekoffData.empid,
      designation: originalWeekoffData.designation,
      status: originalWeekoffData.status,
    });
  };

  
  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/manager-management");
  };


  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "EditManager" && item.can_access
                ) &&
                (togglePage.view || togglePage.edit ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                      {togglePage.view ? "View Manager Details" : "Edit Manager Details"} 
                         
                      </MaterialTypography>
                    </Stack>
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="contained"
                        color="dark"
                        onClick={toggleEdit}
                        startIcon={<EditIcon />}
                        sx={{
                          "&:focus:not(:hover)": {
                            backgroundColor: "#3F51B5d4 !important",
                            boxShadow: "none !important",
                          },
                        }}
                      >
                        Edit
                      </MaterialButton>
                      {/* Uncomment this block to enable delete functionality */}
                      {/* 
                    <MaterialButton
                        variant="contained"
                        color="dark"
                        onClick={onDeleteManager}
                        startIcon={<DeleteIcon />}
                    >
                        Delete
                    </MaterialButton>
                    */}
                    </ButtonGroup>
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Manager Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                ))}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          {togglePage.view === true || togglePage.edit === true ? (
            <Grid direction="row" container spacing={1}>
              <Grid size={{ xs: 10, sm: 8 }}>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="caption" color="text">
                    Employee Name
                  </MaterialTypography>
                  <MaterialTypography
                    variant="h5"
                    fontWeight="bold"
                    style={{
                      whiteSpace: "normal",
                      display: "flex",
                      alignItems: "center",
                      //truncating text after 2 lines
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {viewManagerData.userName}({viewManagerData.empid})
                  </MaterialTypography>
                  <MaterialTypography
                    variant="caption"
                    style={{ fontSize: 12 }}
                  >
                    {viewManagerData.designation || ""}
                  </MaterialTypography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 2, sm: 4 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={viewManagerData.status}
                      name="status"
                      onChange={handleChange}
                      disabled={togglePage.view === true ? true : false}
                    />
                  }
                  label={
                    viewManagerData.status === true ? (
                      <MaterialTypography variant="caption" color="text">
                        Active
                      </MaterialTypography>
                    ) : (
                      <MaterialTypography variant="caption" color="text">
                        In Active
                      </MaterialTypography>
                    )
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox
                  style={{
                    overflow: "hidden",
                    marginTop: 10,
                  }}
                >
                  <MaterialBox mb={2}>
                    <MaterialBox
                      display="flex"
                      align-items="center"
                      justify-content="center"
                    >
                      <img
                        src={manager}
                        alt="manager-management"
                        style={{
                          width: "400px",
                          height: "400px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </MaterialBox>
                  </MaterialBox>
                </MaterialBox>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox mb={2}>
                  <MaterialTypography
                    variant="h6"
                    color="black"
                    style={{
                      maxWidth: "400px",
                      margin: "auto",
                    }}
                  >
                    Switch that manager: choose "<i>Active </i>" Or "
                    <i>inActive </i>" for manager status.
                    <br /> <br />
                    <b>Team Leadership:</b> Inspire and motivate team members to
                    achieve common goals.
                    <br /> <br />
                    <b>Performance Management:</b> Set clear performance
                    expectations and goals for team members.
                    <br /> <br />
                    <b>Resource Allocation:</b> Allocate tasks and resources
                    effectively to maximize team productivity. And manage
                    budgets and project timelines.
                    <br /> <br />
                    <b>Coaching and Development:</b> Identify training needs and
                    facilitate professional development opportunities.
                  </MaterialTypography>
                </MaterialBox>
              </Grid>
            </Grid>
          ) : (
            <>
              <Stack direction="row" spacing={1}>
                <BsFillPersonVcardFill style={{ fontSize: 20 }} />
                <MaterialTypography
                  component="label"
                  variant="body2"
                  fontWeight="bold"
                >
                  User information
                </MaterialTypography>
              </Stack>
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 5, sm: 5 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        User name <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="userName"
                      value={managerData.userName}
                      // defaultValue={{ label: "Mr." }}
                      customStyles={{ optionPadding: 20 }}
                      onChange={handleManagerDataChange} //selectedValue, event
                      options={resource.userName.map((value) => {
                        return {
                          value: value.id,
                          label: value.firstName.toUpperCase(),
                        };
                      })}
                      error={
                        managerData.userNameStatus === "error" ? true : false
                      }
                      success={
                        managerData.userNameStatus === "success" ? true : false
                      }
                      isClearable
                    />
                  </Grid>
                  <Grid size={{ xs: 5, sm: 5 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                       Department 
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="userName"
                      disabled={true}
                      value={Department}
                      // defaultValue={{ label: "Mr." }}
                      customStyles={{ optionPadding: 20 }}
                    
                    />
                  </Grid>
                </Grid>
              </MaterialBox>
            </>
          )}
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={AddDiscard}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkAllFields()}
                onClick={onEditManager}
              >
                Update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <>
               <MaterialButton
                                            sx={{ m: 2 }}
                                            variant="gradient"
                                            color="dark"
                                            onClick={handlecancel}
                                          >
                                            Cancel
                                          </MaterialButton>
            <MaterialButton
             sx={{ m: 2, marginLeft: "4px" }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddManager}
            >
              Submit
            </MaterialButton>
            </>
          ) : null}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddManager;
